import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type { PageResult } from '../types/result';
import type {
  ReplenishAdoptRequest,
  ReplenishAdoptResult,
  ReplenishGenerateResult,
  ReplenishIgnoreRequest,
  ReplenishIgnoreResult,
  ReplenishQuery,
  ReplenishRow
} from '../types/replenish';

const BASE = '/wl/replenish';

/**
 * 自动补货建议（`wl_replenish`）：
 * 规则扫描生成 → 运营采纳生成请购单（QG）/ 忽略。
 */
export function createReplenishApi(http: HttpClient) {
  return {
    list(query: ReplenishQuery = {}): Promise<PageResult<ReplenishRow>> {
      return http.request<PageResult<ReplenishRow>>({ path: BASE, query: toQuery(query) });
    },

    /** 按 `cfg_stock_rule` 规则扫描生成建议（已有 PENDING 建议原地刷新）。 */
    generate(): Promise<ReplenishGenerateResult> {
      return http.request<ReplenishGenerateResult>({ path: `${BASE}/generate`, method: 'POST' });
    },

    /** 采纳建议，生成请购单。 */
    adopt(id: Id, body: ReplenishAdoptRequest = {}): Promise<ReplenishAdoptResult> {
      return http.request<ReplenishAdoptResult>({ path: `${BASE}/${id}/adopt`, method: 'POST', body });
    },

    /** 忽略建议（不生成请购单）。 */
    ignore(id: Id, body: ReplenishIgnoreRequest = {}): Promise<ReplenishIgnoreResult> {
      return http.request<ReplenishIgnoreResult>({ path: `${BASE}/${id}/ignore`, method: 'POST', body });
    }
  };
}

export type ReplenishApi = ReturnType<typeof createReplenishApi>;
